/**
 * 公共商品详情页面脚本
 * 2023年06月14日
 */
var ProductImages = [];


$(function () {
  /**
   * 处理格式化产品详情数据 
   */
  function productDes() {
    // 除了第一个隐藏 后面所有
    $("#pr_des_warp .tab_title_block").first().addClass('active');
    $("#pr_des_warp .des_item").hide();
    $("#pr_des_warp .des_item:lt(1)").show();
    // 监听事件
    $(".container_des").on("click", '.tab_title_block', function () {
      const mid = $(this).attr("id");
      // 移出所有的class
      $("#pr_des_warp .tab_title_block").removeClass('active');
      $(this).addClass('active');
      $("#pr_des_warp .des_item").each(function () {
        let selId = $(this).attr('id');
        if (selId == mid) {
          $(this).show();
        } else {
          $(this).hide();
        }
      })
    });

    // 优惠券是否倒计时功能
    const countdown = $('#pprDiscountTime').attr('attr-countdown');
    if (countdown) {
      const ends = $('#pprDiscountTime').attr('ends');
      const days = $('#pprDiscountTime').attr('days');
      const hours = $('#pprDiscountTime').attr('hours');
      const minutes = $('#pprDiscountTime').attr('minutes');
      const secs = $('#pprDiscountTime').attr('secs');
      startCountdown(countdown, 'pprDiscountTime', ends, days,hours,minutes,secs);
    }

    // 初始化二级变体
    if (!isMobile()) {
      $('.size_medium .swatch:gt(0)').each(function(){
         $(this).find('.swatch__list_pr:not(.j-swatch-list) .swatch_pr_item:gt(2)').hide();
         console.log($(this).find('.swatch__list_pr .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-even-more)').length)
         let swatchNum = $(this).find('.swatch__list_pr .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-even-more)').length - 3;
         if(swatchNum > 0) {
          $(this).find('.j-swatch-even-more').text('+' + swatchNum).show();;
         }
      })
    }
    // 移动端
  }

  function mDataProcessing() {
    $('.j-swatch-more').hide();
    $('.j-swatch-even-more').hide();

    // 描述点击事件
    $('#pr_des_warp').on('click', '.tab_title_block', function (e) {
      if ($(this).find('.op-fold').hasClass('opened')) {
        $(this).find('.op-fold').removeClass('opened');
        $(this).find('.m-deatil').stop().slideUp(200);
      } else {
        $(this).find('.op-fold').addClass('opened');
        $(this).find('.m-deatil').stop().slideDown(200);
      }
    });
    $('#pr_des_warp .tab_title_block')[0].click()

  }

  /**
 * 初始化方法
 */
  function init() {
    // 处理详情数据
    productDes();
    // 所有事件监听
    productListenEvent();
    // 移动端判断
    if (isMobile()) {
      mDataProcessing();
    } else {
      var intervalLaw = setInterval(function () {
        if ($('#shopify-section-cookies_law.pp_onshow').length > 0 || $('#shopify-section-cookies_law.pp_onhide').length > 0) {
          let flag = $('#shopify-section-cookies_law.pp_onshow').length > 0;
          if (flag) {
            $('#p_floatCart').css({ 'bottom': '65px' });
          } else {
            $('#p_floatCart').css({ 'bottom': '0px' });
          }
          clearInterval(intervalLaw)
        }
      }, 1000)
      $('body').on('click', '.pp_cookies_accept_btn', function (e) {
        $('#p_floatCart').css({ 'bottom': '0px' });
      });
    }
    const payName = $('.zl-product-payment').attr('title');
    // 延迟更新
    // 更改直接购买名称
    payment(payName);
  }
  init();
})

/**
 * 循环执行修改名称
 */
function payment(payName) {
  // 默认循环10次
  var num = 0;
  var interval = setInterval(function () {
    // 最多执行10次
    if (num > 9){
      clearInterval(interval);
    }
    $('#p_floatCart').show();
    if ($(`.zl-product-payment .shopify-payment-button__more-options`).text() == payName) {
      $(`.zl-product-payment`).css({ 'opacity': 1 })
      clearInterval(interval);
    } else {
      $(`.zl-product-payment .shopify-payment-button__more-options`).text(payName);
    }
    num++;
  }, 1000)
}

/**
 * 产品所有事件监听方法
 * 2023-06-16
 */
function productListenEvent() {
  // j-swatch-more"
  // more 更多点击事件
  $('.p_ProductInner').on('click', '.j-swatch-more', function (e) {
 
    $(this).parents('.swatch').find('.swatch_list_show').stop().slideDown(200);
    //  j-swatch_show
  });
  // .slideUp(200);

  //  选择颜色事件
  $('.p_ProductInner').on('click', '.j-swatch-list .swatch_pr_item', function (e) {
    const index = $(this).attr("data-index"),parid=$(this).parent(".j-swatch-list").data("id");
  console.log(parid,"index");
    // 当前选项的展示list
    const swatchItem = $(`.nt_select_ppr${parid} .swatches-select .swatch_pr_item:not(.j-swatch-more)`);
    // 默认显示 3个
    swatchItem.hide();
   // 计算需要显示的元素范围
   let startIndex = Math.max(index - 2, 0);
   let endIndex = Math.min(index, swatchItem.length - 1);
   
   if (index === '0') {
    endIndex = Math.min(index + 2, swatchItem.length - 1);
}
 
if(index!=1){
  swatchItem.slice(startIndex, endIndex + 1).show();
}
else{
  swatchItem.slice(0,3).show();
}

   // 显示计算范围内的元素
   
   
   // 当前索引
    $(swatchItem).eq(index).show().click();
    // 当前选中的放在最前面
    $(this).parents('.swatch').find('.swatch_list_show').slideUp(200);
    // 处理二级分类
      setTimeout(function () {
      $(`.nt_select_ppr${parid+1} .swatch__list_pr .swatch_pr_item`).not('.j-swatch-even-more').show();
      $(`.nt_select_ppr${parid+1}  .swatch__list_pr .swatch_pr_item:gt(2)`).not('.j-swatch-even-more').hide();
    }, 300)
  });

  // moer 变体二以上的点击事件
  $('.p_ProductInner').on('click', '.j-swatch-even-more', function (e) {
    let value = $(this).parents('.swatch').find('.swatches-select .is-selected').attr('data-escape');
    $(this).parents('.swatch').find('.j-swatch_even_show .j-swatch-even—active').text(value);
    $(this).parents('.swatch').find('.j-swatch_even_show').show();
 
    //  j-swatch_show
  });

  // 选择颜色事件
  $('.p_ProductInner').on('click', '.j-swatch-even-list .swatch_pr_item', function (e) {
    const index = $(this).attr("data-index");
    const ths =  $(this).parents('.swatch').find('.swatches-select');
    const swatchItem = $(ths).find('.swatch_pr_item:not(.j-swatch-even-more)');


 // 计算需要显示的元素范围
 let startIndex = Math.max(index - 2, 0);
 let endIndex = Math.min(index, swatchItem.length - 1);
 
 if (index === '0') {
  endIndex = Math.min(index + 2, swatchItem.length - 1);
}

if(index!=1){
swatchItem.slice(startIndex, endIndex + 1).show();
}
else{
swatchItem.slice(0,3).show();
}

    


    // 当前索引
    $(swatchItem).eq(index).show().click();
    // 隐藏弹出框
    $(this).parents('.swatch').find('.j-swatch_even_show').hide();
  });
  // 优惠码 复制
  $(".p_ProductInner .j-discount-copy").on('click', function (event) {
    const text = $(this).attr('text');
    const successText = $(this).attr('success');
    const defText = $(this).attr('defText');

    copyTxt(text)
    $(this).parents('.item').addClass("copied");
    // event.preventDefault();
    $(this).text(successText);
    let that = this;
    // copy le code
    setTimeout(function () {
      $(that).parents('.item').removeClass("copied");
      $(that).text(defText);
    }, 1500)
  });

  // why-choose 点击事件
  if (!isMobile()) {
    $(".p_ProductInner .why-choose").on('click', function (event) {
      $(this).addClass('active');
    })
  }


  $('#sp_qty_ppr .qty').on('change', function () {
    $('.sticky_atc_wrap .qty').val($(this).val());
  });

  // 隐藏
  $('body').on('click', function (e) {
    var target = $(e.target);
    if (target[0].className == 'las la-angle-down') {
      $('.j-swatch_show').slideUp(200);
      $('.j-swatch_even_show').slideUp(200);
    }
    if (target.closest('.swatch_more').length > 0 || target.closest('.box-head').length > 0 || target.closest('.swatch__list_pr').length > 0) return;

    if (target.closest('.swatch_even_more').length > 0 || target.closest('.j-swatch-even-list').length > 0) return;
    $('.j-swatch_show').slideUp(200);
    $('.j-swatch_even_show').slideUp(200);

    if (target.closest('.j-why-item').length > 0) return;
    $('.why-choose').removeClass('active');
  });

  // 三点描述 调整到底部
  $('.p_ProductInner').on('click', '.j-simple-desc', function (e) {
    var hTop = $('.container_des').offset().top;
    $('body,html').animate({
      scrollTop: hTop - 100
    }, 700);
    // 选中第一个
    $('.container_des .tab_title_block')[0].click();
  })
}

/**
 * 格式化产品文字
 * variantId 变体对象id
 * */
function formatProduct(id,pid,type) {
  _productHtml = '';
  console.log('formatProduct -----');
  // 处理描述内容
  if(type!="qv"){
  var variantMetafields = gProductJson.variants.filter(x => x.id == id)
  variantMetafields = variantMetafields[0];
  
  var _htmlFeatures = variantMetafields.features||"";
  var _tempFeatures = '<ul class="left">';
  for (let i = 0; i < _htmlFeatures.length; i++) {
    if (_htmlFeatures[i] !== '') {
      _tempFeatures += `<li>${_htmlFeatures[i].replace(/\s/g, ' ')}</li>`;
    }
  }
  _tempFeatures += `<li>EAN: ${variantMetafields.ean}</li>`;
  _tempFeatures += '</ul>'
  $('#pr_des_warp .key_features').html(_tempFeatures)

  // 更新title
  var brand = $('.product_title').attr("data-name");
  $('.product_title').html(brand + ' ' + variantMetafields.title);

  // 更新 Specifications
  let prDescHtml = '';
  if (variantMetafields.specifications.length > 0 || variantMetafields.packages.length > 0) { // specifications
    let _speciHtml = '<ul><div class="left"><li><b>Specifications:</b></li>';
    let _specifications = variantMetafields.specifications
    for (let i = 0; i < _specifications.length; i++) {
      _speciHtml += `<li>${_specifications[i]
        }</li>`;
    }
    let packagesHtml = '';
    for (let i = 0; i < variantMetafields.packages.length; i++) {
      packagesHtml += `<li>${variantMetafields.packages[i]
        }</li>`;
    }
    _speciHtml += `</div><div class="right"><span style="font-weight: 700;">Package&nbsp;Contents:</span>
          <br><div>${packagesHtml}</div></div>`;
    _speciHtml += '</ul>'
    $('#pr_des_warp .description').html(_speciHtml);
    prDescHtml = _speciHtml
  } else {
    prDescHtml = variantMetafields.descriptions
  }
  $('#pr_des_warp .description').html(prDescHtml);

  // faq QA
  var faq = '';
  var _faqHtml = '<div class="ziel-qa-list"><ul>';
  var faqList = variantMetafields.faqs;
  if (faqList.length < 1) {
    faqList = defaultFaq;
  }
  for (let i = 0; i < faqList.length; i++) {
    let ths = faqList[i];
    _faqHtml += `<li><label>Q: ${ths.question
      }</label><span>A: ${ths.answer
      }</span></li>`
  }
  _faqHtml += '</ul></div>'
  $('#pr_des_warp .questions_answers').html(_faqHtml);
  // 图片
  ProductImages = variantMetafields.images;

  // 处理二个变体的情况
  // 处理 变体的情况
  $('.size_medium .swatch:gt(0)').each(function () {
    let swatchNum = $(this).find('.swatches-select .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-even-more)').length;
    if (swatchNum > 3 && !isMobile()) {
      $(this).find('.j-swatch-even-more').show();
      $(this).find('.j-swatch-even-more').text(`+${swatchNum - 3}`);
    } else {
      $(this).find('.j-swatch-even-more').hide();
      setTimeout(function () {
        $(this).find('.swatch__list_pr .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-even-more)').show();
      }, 500)
    }
  })
}

 

  // 处理二级变体变成 nt_unavailable 问题；
  $('.j-swatch_even_show').slideUp(200);
  var _html = $('.nt_select_ppr1 .swatches-select').html();
  var _this = $('.j-swatch-even-list').html(_html);
  $(_this).find('.j-swatch-even-more').remove();
  $(_this).find('.nt_unavailable').remove();
  $(_this).find('.swatch_pr_item').show();

  // 初始化图片
  initProductImages();

  // 判断是否有亚马逊链接
  /**
   * 无库存时将到货通知的按钮样式替代为 buy on amzon，并点击跳转到对应 attribution link；
     当商品在shopify的inventory stock>0 或 tag有 “new” or “New” ，隐藏buy on amazon按钮，恢复正常按钮
     attribution link数据由中台提供，stock>0/new tag由shopify提供
   */
     if(type!="qv"){
  if ((variantMetafields.inventory_quantity) == 0 && !(gProductJson.tags.includes("new") || gProductJson.tags.includes("New"))) {
    if (variantMetafields.amazon_url){
      $(`.p_floatCart-${pid} .box-outStock .btn-amazon`).removeClass('klaviyo-bis-trigger').attr('href', variantMetafields.amazon_url).attr("target", "_blank").text('Buy on amazon')
    } else {
      let text = $('.box-outStock .btn-amazon').attr('klaviyo');
      $(`.p_floatCart-${pid} .box-outStock .btn-amazon`).addClass('klaviyo-bis-trigger').attr('href', '').attr("target", "").text(text);
    }
  }
  console.log("45646787",variantMetafields.available, variantMetafields.inventory_quantity);
  // 判断是否有库存
  if ((variantMetafields.inventory_quantity) > 0 || Boolean(variantMetafields.available)) {
    stockDisplay(true,pid);

  } else {
    stockDisplay(false,pid);
  }
  // 判断是否是预购
  if((variantMetafields.inventory_quantity) == 0 && Boolean(variantMetafields.available)) {
    // 预购
    console.log('pre order ---- 添加样式');
    $(`.p_floatCart-${pid} .m-btns`).addClass('pre-order');
    // 添加样式
  } else {
    $(`.p_floatCart-${pid} .m-btns`).removeClass('pre-order');
  }
}

}


/**
 * 倒计时
 */
function startCountdown(date, id, ends, _days,_hours,_minutes,_secs) {
  const targetDate = new Date(date);
  const countdownElement = document.getElementById(id);
  function updateCountdown() {
    const currentDate = new Date();
    const remainingTime = targetDate - currentDate;
    if (remainingTime <= 0) { 
      return;
    }
    let _countdownHtml = ends;
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    //判断是否倒计时结束
    // days.toString().padStart(2, "0")

    _countdownHtml += `${days} ${_days} `;
    
   
    _countdownHtml += `${hours.toString().padStart(2, '0')}${_hours} `;
  
    _countdownHtml += `${minutes.toString().padStart(2, '0')}${_minutes} `;
 
    _countdownHtml += `${seconds.toString().padStart(2, '0')}${_secs} `;

 
    countdownElement.innerHTML = _countdownHtml;
    setTimeout(updateCountdown, 1000);
  }
  updateCountdown();
}
/**
 * 库存显示
 * true 显示
 */
function stockDisplay(flag,pid) {
  console.log('init - cart ', flag,pid);
  if (flag) {
    //  新版本 有库存
    $(`.p_floatCart-${pid} .sticky_total_price`).show();
    $(`.p_floatCart-${pid} .sticky_atc_js`).show()
    $(`.p_floatCart-${pid} .discount-recommended`).show();
    $(`.p_floatCart-${pid} .box-outStock`).removeClass('active');
    $(`.p_floatCart-${pid} .box-outStock a`).hide();
    $(`.p_floatCart-${pid} .m-btns`).show();
    $(`.product[data-pid="${pid}"] .buy-and-add-button-box`).show();
    $(`.p_floatCart-${pid} .box-outStock .btn-stock`).text("");
    $('.p-main-image .nt_labels .out-of-stock').text("").hide();
    //  没有库存隐藏移动端折扣信息
    if (isMobile() && $('.m-discount-block').attr("attr-save") > 0 ) {
      $(`.p_floatCart-${pid} .m-price`).show();
      $(`.p_floatCart-${pid} .m-discount-block`).show();
    }
  } else {
    // 底部没有库存判断
 $(`.p_floatCart-${pid} .box-outStock .btn-stock`).text("Sold out");
    $('.p-main-image .nt_labels .out-of-stock').text("Sold out").show();
    $(`.p_floatCart-${pid} .sticky_atc_price`).hide();
    $(`.p_floatCart-${pid} .m-price`).hide();
    $(`.p_floatCart-${pid} .sticky_atc_js`).hide()
    $(`.p_floatCart-${pid} .discount-recommended`).hide();
    $(`.p_floatCart-${pid} .box-outStock`).addClass('active');
    $(`.p_floatCart-${pid} .box-outStock a`).show();
    $(`.p_floatCart-${pid} .m-btns`).hide();
    $(`.product[data-pid="${pid}"] .buy-and-add-button-box`).hide();
    
    //  没有库存隐藏移动端折扣信息
    if (isMobile()) {
      $(`.p_floatCart-${pid} .m-discount-block`).hide();
    }
  }
}